import { BaseWidget } from '@eduact/ed-components'
import { rgba } from 'polished'
import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { MdChevronLeft, MdChevronRight } from 'react-icons/md'
import styled from 'styled-components'
import { InvoicesWidget } from './Components/InvoicesWidget'
import TimelineWidget from './Components/TimelineWidget/TimeLineWidget'
import WalletHistoryWidget from './Components/WalletWidget/WalletHistoryWidget'
import { ManualVcWidget } from '@Features/ManualVc/ManualVc'
import { manualVcBase } from '@Features/ManualVc/ManualVc.api'

const Activity = () => {
	const { t, i18n } = useTranslation('wallet')
	return (
		<Container>
			<QuickLinks>
				<Link to={manualVcBase}>
					{t('manual_vc.history')}
					{i18n.dir() === 'rtl' ? <MdChevronLeft aria-hidden="true" /> : <MdChevronRight aria-hidden="true" />}
				</Link>
			</QuickLinks>
			<HistoryGrid>
				<WalletHistoryWidget />
				<TimelineWidget />
			</HistoryGrid>
			<ManualVcWidget />
			<BaseWidget onClick={() => {}} widget={InvoicesWidget} widgetProps={{}} />
		</Container>
	)
}
export default Activity

const Container = styled.div`
	background: ${rgba('#FFF', 0.5)};
	width: 100%;
	min-width: 0;
	display: grid;
	align-content: start;
	gap: 20px;
	padding: 11px;
	border-radius: 15px;
	${({ theme }) => `${theme.mediaQueries.large}{ padding: 0; background: transparent; }`}
`
const HistoryGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	gap: 20px;
	min-width: 0;
	${({ theme }) => `${theme.mediaQueries.large}{ grid-template-columns: repeat(2,minmax(0,1fr)); }`}
`
const QuickLinks = styled.nav`
	display: flex;
	justify-content: flex-end;
	min-width: 0;
	a {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		color: ${({ theme }) => theme.colors.independence};
		font-size: 0.8125rem;
		text-underline-offset: 3px;
	}
	a:focus-visible {
		outline: 2px solid ${({ theme }) => theme.colors.primary};
		outline-offset: 4px;
	}
`
